<template>
    <div class="contrainer">
        <div class="row text-modal-redeem">
            <div class="col-12 text-center">
                <div class="title" v-html="msg">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BuyConfirmRedeem',
    props: {
        lbl: Object,
        campaign: Object
    },
    data: function () {
        return {
            msg: ''
        };
    },
    created: function () {
        this.msg = this.lbl.confirm_redeem.buy;
    }
}
</script>
<style lang="scss">
@import "@/components/Modal/Redeem/ConfirmRedeem/Component/cfModal.scss";
</style>
